import CardFilaEspera from './CardFilaEspera'
import ListaFilaAgendados from './ListaFilaAgendados'
import ProcedimentosSaude from './index.vue'
import ListaFilaEspera from './ListaFilaEspera'
import EstatisticaTotalAgendamentos from './EstatisticaTotalAgendamentos'
import EstatisticaTempoMedio from './EstatisticaTempoMedio'

export * from './datatableFields'

export {
  CardFilaEspera,
  ListaFilaEspera,
  ListaFilaAgendados,
  ProcedimentosSaude,
  EstatisticaTotalAgendamentos,
  EstatisticaTempoMedio
}



// WEBPACK FOOTER //
// ./src/components/ProcedimentosSaude/index.js